module.exports = __webpack_public_path__ + "img/placeholder-image.91041109.png";